import React from 'react'

import { useCountdownFSBonusStore, useFreeSpinsBonusesStore, useLuckySpinsStore } from '@stores'

import RemainingSpinsBanner from './RemainingSpinsBanner'

const RemainingSpinsBannerWrapper: React.FC = () => {
    const fsShowRemainingSpinsBanner = useFreeSpinsBonusesStore((state) => state.showRemainingSpinsBanner)
    const lsShowRemainingSpinsBanner = useLuckySpinsStore((state) => state.showRemainingSpinsBanner)
    const cfsShowRemainingSpinsBanner = useCountdownFSBonusStore((state) => state.showRemainingSpinsBanner)

    const showRemainingSpinsBanner =
        fsShowRemainingSpinsBanner || lsShowRemainingSpinsBanner || cfsShowRemainingSpinsBanner

    return <>{showRemainingSpinsBanner && <RemainingSpinsBanner />}</>
}

export default RemainingSpinsBannerWrapper
